var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ca-header',{attrs:{"heading":"GVC's"}}),_c('div',{staticClass:"container-fluid px-4 pt-4"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }